
const dmanTable = {
  state: {
    dmanTableState: false,
    dmanTableBranchId: '',
    dmanTableBranchName: '',
    dmanTableUserId: '',
    dmanTableUserName: '',

    dmanTableSqType: '',
    dmanTableProjcetId: ''
  },

  mutations: {
    SET_DMANTABLESTATE: (state, dmanTableState) => {
      state.dmanTableState = dmanTableState
    },
    SET_DMANTABLEBRANCHID: (state, dmanTableBranchId) => {
      state.dmanTableBranchId = dmanTableBranchId
    },
    SET_DMANTABLEBRANCHNAME: (state, dmanTableBranchName) => {
      state.dmanTableBranchName = dmanTableBranchName
    },
    SET_DMANTABLEUSERID: (state, dmanTableUserId) => {
      state.dmanTableUserId = dmanTableUserId
    },
    SET_DMANTABLEUSERNAME: (state, dmanTableUserName) => {
      state.dmanTableUserName = dmanTableUserName
    },
    SET_DMANTABLESQTYPE: (state, val) => {
      state.dmanTableSqType = val
    },
    SET_DMANTABLEPROJECTID: (state, val) => {
      state.dmanTableProjcetId = val
    },
  },

  actions: {
    
  }
}

export default dmanTable
